import type { JournalPathPoint } from '../types'

export function pathSummary(points: readonly JournalPathPoint[]) {
  if (points.length === 0) return null
  const pnl = points.map((point) => point.pnl)
  const range = (key: 'delta' | 'gamma' | 'theta' | 'vega') => ({
    low: Math.min(...points.map((point) => point[key])),
    high: Math.max(...points.map((point) => point[key])),
  })
  return {
    mae: Math.min(0, ...pnl), mfe: Math.max(0, ...pnl),
    ivPeak: Math.max(...points.map((point) => point.iv)),
    delta: range('delta'), gamma: range('gamma'), theta: range('theta'), vega: range('vega'),
  }
}
